import { useContext } from 'react'

import { CartIntermediateContext } from '../context/CartIntermediateContext'
import { type CartIntermediateContextValue } from '../model/CartIntermediateContextValue'

export const useCartIntermediateContext = (): CartIntermediateContextValue => {
  const contextValue = useContext(CartIntermediateContext)
  if (contextValue === undefined) {
    throw new Error(
      'useCartIntermediateContext must be used within a CartIntermediateContextProvider',
    )
  }

  return contextValue
}
